import { render, staticRenderFns } from "./AddSectorOrRouteBtn.vue?vue&type=template&id=2fc790ca"
import script from "./AddSectorOrRouteBtn.vue?vue&type=script&lang=js"
export * from "./AddSectorOrRouteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports